import Meta from '@src/components/Meta';
import PageTemplate from '@src/components/Template/Page';
import SponserTemplate from '@src/components/Template/Sponser';
import { metaInfo } from '@src/data/meta';

export default function Sponser() {
  const { sponser } = metaInfo;
  return (
    <>
      <Meta
        title={sponser.title}
        description={sponser.description}
        ogImage={sponser.ogImage}
      />
      <SponserTemplate />
    </>
  );
}
